export default __webpack_public_path__ + "static/gearsTactics-3a03d803e1b94d790c2d1bdf11b67da3.svg";